var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrailer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512,297.5c-4.5,10.4-12.4,14.6-23.8,13.9c-10.3-0.6-5.2-0.1-16.1-0.1c0,2.8,0,5,0,7.3c0,21.7,0,43.4,0,65 c0,11.6-7.9,19.9-18.6,19.8c-10.4-0.1-18.2-8.3-18.2-19.6c-0.1-21.9,0-43.7,0-65.6c0-2.1,0-4.1,0-6.5c-74.2,0-85.8,0-159.6,0 c5.6,46.2-30.1,90.5-80.3,91.7c-49.8,1.2-89.8-42-84.3-92.1c-2.1,0-4.2,0-6.3,0c-22.1,0-44.1,0-66.2,0c-23-0.1-38.6-15.7-38.6-38.7 c0-47.8,0-95.5,0-143.3c0-13.4,7.3-20.6,20.7-20.6c127.4,0,254.8,0,382.2,0c13.6,0,20.9,7.3,20.9,21c0,45.7,0,91.3,0,137 c0,2.3,0,4.6,0,7.8c2.4,0,4.6,0,6.8,0c45.1,0,12.6,0.2,57.7-0.2c11.3-0.1,19.2,3.6,23.8,14C512,291.3,512,294.4,512,297.5z  M37,274.1c1.2,0.1,2,0.3,2.7,0.3c27,0,54.1,0.1,81.1-0.2c2.3,0,5.2-2.1,6.7-4c33.5-43.5,98.4-43.6,131.7,0.1 c2.4,3.1,4.7,4.2,8.6,4.2c37.8-0.1,75.6-0.1,113.4-0.1c1.8,0,3.7-0.2,5.3-0.2c0-43.2,0-85.9,0-128.2c-116.8,0-233.1,0-349.5,0 C37,188.8,37,231.2,37,274.1z M193.3,274.4c-25.4,0.1-46,20.8-45.9,46.3c0.1,25.2,20.8,45.8,45.9,45.8c25.7,0,46.4-20.8,46.2-46.6 C239.3,294.8,218.6,274.4,193.3,274.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailer);
export default __webpack_public_path__ + "static/media/trailer.d4a2f26f29d6388bcac898f63baafa1f.svg";
export { ForwardRef as ReactComponent };